import siteConfig from "site-config";
import { MERCHANT_ENABLEMENTS } from "constants/action-types";

import { ajax } from "../lib/observable";
import { Observable } from "rxjs";

export const fetchMerchantEnablementsEpic = (action$) => {
    return action$.ofType(MERCHANT_ENABLEMENTS.FETCH.START).concatMap(() =>
        ajax({
            method: "GET",
            url: `${siteConfig.api}/lightspeed-b2b/api/v1/merchant-enablement/enablements`,
        })
            .flatMap(({ response }) => [{ payload: response, type: MERCHANT_ENABLEMENTS.FETCH.SUCCESS }])
            .catch((error) => Observable.of({ error: true, payload: error, type: MERCHANT_ENABLEMENTS.FETCH.ERROR }))
    );
};
